import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { MdDashboard, MdPostAdd, MdBusiness, MdLogout } from "react-icons/md";
import "./Joblayout.css";
import { Avatar } from "antd";
// import BarChart from "../../../asset/svgs/BarChart";
import { useGetUser } from "../hooks/useUser";

const Sidebar = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeItem, setActiveItem] = useState("dashboard");

  const { data: user, loading, error, getCurrentUser } = useGetUser();
  const userId = localStorage.getItem("jobUserId");
  useEffect(() => {
    const fetchUser = async () => {
      await getCurrentUser(userId);
    };

    fetchUser();
  }, [getCurrentUser, userId]);

  const handleRefetch = async (userId) => {
    await getCurrentUser(userId);
  };
  // Default user info fallback
  const userInfo = {
    name: user?.company_name || "Company Name",
    avatar:
      user?.company_logo ||
      "https://api.dicebear.com/7.x/avataaars/svg?seed=default",
    email: user?.email || "companyname@mail.com",
  };
  // console.log("USER PROFILE:", user);
  const menuItems = [
    {
      id: "dashboard",
      label: "Dashboard",
      icon: MdDashboard,
      // icon: BarChart,
      path: "/jobs/job-admin",
    },
    {
      id: "job-posts",
      label: "Job Post",
      icon: MdPostAdd,
      path: "/jobs/job-admin/job-posts",
    },
    {
      id: "company-profile",
      label: "Company Profile",
      icon: MdBusiness,
      path: "/jobs/job-admin/company-profile",
    },
  ];

  // Sync active item with current route
  useEffect(() => {
    const currentPath = location.pathname;

    let currentActiveItem;

    if (currentPath.includes("/job-admin/job-posts")) {
      currentActiveItem = "job-posts";
    } else if (currentPath.includes("/job-admin/company-profile")) {
      currentActiveItem = "company-profile";
    } else {
      currentActiveItem =
        menuItems.find((item) => item.path === currentPath)?.id || "dashboard";
    }

    setActiveItem(currentActiveItem);

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  // Handle menu item click
  const handleMenuClick = (id, path) => {
    setActiveItem(id);
    navigate(path);
    if (isOpen) onClose();
    console.log(`Navigating to: ${path}`);

  };

  // Handle logout
  const handleLogout = () => {
    // const userId = localStorage.getItem("jobUserId");

    // if (userId && authLogout) {
    //   authLogout(userId);
    // }

    // Clear all auth data
    localStorage.removeItem("jobToken");
    localStorage.removeItem("jobUserId");
    localStorage.removeItem("jobRefreshToken");

    // Redirect to login
    navigate("/jobs/job-auth");
  };

  // If there's an error and we're not authenticated, might want to redirect

  return (
    <>
      {isOpen && <div className="job-sidebar-overlay" onClick={onClose} />}
      <aside className={`job-sidebar ${isOpen ? "open" : ""}`}>
        <div className="job-sidebar-content">
          <div className="job-sidebar-user-box">
            <div className="job-sidebar-user-info">
              {loading ? (
                <div className="loading-state">
                  <Avatar size={48} style={{ backgroundColor: "#f5f5f5" }}>
                    <div className="loading-spinner">...</div>
                  </Avatar>
                  <div className="job-sidebar-user-details">
                    <p className="job-sidebar-user-name">Loading...</p>
                    <p className="job-sidebar-user-email">Please wait</p>
                  </div>
                </div>
              ) : error ? (
                <div className="error-state">
                  <Avatar size={48} style={{ backgroundColor: "#ff4d4f" }}>
                    !
                  </Avatar>
                  <div className="job-sidebar-user-details">
                    <p className="job-sidebar-user-name">Error loading user</p>
                    <button
                      onClick={handleRefetch}
                      className="retry-button"
                      style={{
                        background: "none",
                        border: "none",
                        color: "#1890ff",
                        cursor: "pointer",
                        fontSize: "12px",
                      }}
                    >
                      Retry
                    </button>
                  </div>
                </div>
              ) : (
                <>
                  <Avatar
                    size={48}
                    src={userInfo.avatar}
                    style={{
                      backgroundColor: "#f5f5f5",
                    }}
                  >
                    {userInfo.name?.charAt(0)?.toUpperCase() || "A"}
                  </Avatar>
                  <div className="job-sidebar-user-details">
                    <p className="job-sidebar-user-name">{userInfo.name}</p>
                    <p className="job-sidebar-user-email">{userInfo.email}</p>
                  </div>
                </>
              )}
            </div>
          </div>

          <nav className="job-sidebar-nav">
            {menuItems.map((item) => {
              const Icon = item.icon;
              return (
                <button
                  key={item.id}
                  onClick={() => handleMenuClick(item.id, item.path)}
                  className={`job-sidebar-nav-item ${
                    activeItem === item.id ? "active" : ""
                  }`}
                  aria-label={`Navigate to ${item.label}`}
                >
                  <Icon size={20} />
                  <span>{item.label}</span>
                </button>
              );
            })}
          </nav>
        </div>

        <div className="job-sidebar-footer">
          <div className="job-sidebar-logout-container">
            <button
              className="job-sidebar-logout-btn"
              onClick={handleLogout}
              aria-label="Log out"
            >
              <MdLogout size={20} />
              <span>Log Out</span>
            </button>
          </div>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
